<div style="text-align: center; margin-top: 100px;">
  <ic-title [isH1Title]="true">🚫 You are Offline</ic-title>
  <ic-title [isParagraph]="true">Please check your internet connection.</ic-title>
</div>

